import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import classnames from 'classnames';
import { changeExitingStatus, setAnimationStage, setActivePetri, hideChooseABacteriaSection, setReturning } from '../actions';
import * as ReactGA from 'react-ga';
import { imagesToPreload } from "../config/images-to-preload";

// Components
import CircleWithBorder from '../components/circle-with-border';
import PetriDish from '../components/petri-dish';
import Squiggle from "../components/squiggle";
import RightArrow from "../components/right-arrow";
import Loader from "../components/loader";


import { getRandomCombination } from "../config/petri-combinations";
import Button from "../components/button";



class WelcomePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isExiting: false
        };

        this.imagesToPreload = imagesToPreload;

        this.petriTicker = null;
        this._startExhibition = this._startExhibition.bind(this);
    }

    componentDidMount() {
        const { refreshApp, setActivePetri, returning, setReturning } = this.props;
        refreshApp();

        this.petriTicker = setInterval( () => {
            setActivePetri( getRandomCombination() );
        }, 6000 );

        if( returning ) {
            window.location.reload();
        }else{
            setReturning();
        }

        ReactGA.pageview('/',null,'Welcome Page');
    }

    componentWillUnmount() {
        clearInterval( this.petriTicker );
    }

    _startExhibition() {
        const { pushToAnimation } = this.props;
        this.setState({
            isExiting: true
        });
        setTimeout(() => {
            pushToAnimation();
        },1000);
    }

    render() {
        const { isExiting } = this.state;
        const { headerColour, squiggleColour } = this.props;
        const pageClassNames = classnames(
            'welcome-page',
            {'exit' : isExiting}
        );

        // I'm setting a key here with the classnames to force a re-render of this component with an exit animation.
        return(
            <div key={ pageClassNames } className={ pageClassNames }>
                <div className="welcome-page-header-container">
                    <PetriDish />
                    <CircleWithBorder size="large">
                        <h1 style={ { color: headerColour } }><span>Bacteria</span> <span>Explorer</span></h1>
                    </CircleWithBorder>
                </div>
                <div className="welcome-page-intro-container">
                    <div className="welcome-page-intro">
                        <div className="squiggle-container" style={ { color: squiggleColour } }>
                            <Squiggle className="welcome-page-squiggle" surpressUpdate />
                        </div>
                        <h2>Dive into the Bacterial World</h2>
                        <p>Bacteria exist on a microscopic scale, but take many forms. Rods, spheres, spirals, corkscrews, and other sizes and shapes influence their many abilities.</p>
                        <p><em>Journey from the human scale into a microscopic world to explore five of the most common bacterial forms.</em></p>
                        <div className="btn-container">
                            <Button className="btn-large btn-right" onClick={ this._startExhibition }>
                                Start
                                <RightArrow/>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = ( state ) => {
  return {
      returning: state.returning,
      headerColour: state.activePetri.colour,
      squiggleColour: state.activePetri.secondaryColour
  }
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        pushToAnimation: () => {
            dispatch( push( process.env.PUBLIC_URL + '/choose-a-bacteria') );
        },
        refreshApp: () => {
            dispatch(changeExitingStatus(false));
            dispatch(setAnimationStage(1));
            dispatch(hideChooseABacteriaSection());
        },
        setActivePetri: ( petri ) => {
            dispatch( setActivePetri( petri ) );
        },
        setReturning: () => {
            dispatch( setReturning() );
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(WelcomePage);



// WEBPACK FOOTER //
// ./src/pages/welcome-page.js